// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__Aaq10","footerContainer":"Footer_footerContainer__DfQdI","footerGridItem":"Footer_footerGridItem__IdJwD"};